"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APIcon.css");
var _iconNavSpot = _interopRequireDefault(require("../../../images/icons/icon-nav-spot.svg"));
var _iconNavMargin = _interopRequireDefault(require("../../../images/icons/icon-nav-margin.svg"));
var _iconNavFutures = _interopRequireDefault(require("../../../images/icons/icon-nav-futures.svg"));
var _iconNavBuySell = _interopRequireDefault(require("../../../images/icons/icon-nav-buy-sell.svg"));
var _iconNavDashboardOn = _interopRequireDefault(require("../../../images/icons/icon-nav-dashboard-on.svg"));
var _iconNavTrading = _interopRequireDefault(require("../../../images/icons/icon-nav-trading.svg"));
var _iconNavAssets = _interopRequireDefault(require("../../../images/icons/icon-nav-assets.svg"));
var _iconNavActivity = _interopRequireDefault(require("../../../images/icons/icon-nav-activity.svg"));
var _iconNavStreaming = _interopRequireDefault(require("../../../images/icons/icon-nav-streaming.svg"));
var _iconNavOpenTerm = _interopRequireDefault(require("../../../images/icons/icon-nav-open-term.svg"));
var _iconNavFixedTerm = _interopRequireDefault(require("../../../images/icons/icon-nav-fixed-term.svg"));
var _iconNavUser = _interopRequireDefault(require("../../../images/icons/icon-nav-user.svg"));
var _iconNavSettings = _interopRequireDefault(require("../../../images/icons/icon-nav-settings.svg"));
var _iconNavWallet = _interopRequireDefault(require("../../../images/icons/icon-nav-wallet.svg"));
var _iconBalance = _interopRequireDefault(require("../../../images/icons/icon-balance.svg"));
var _iconActivity = _interopRequireDefault(require("../../../images/icons/icon-activity.svg"));
var _iconMarginNavNotification = _interopRequireDefault(require("../../../images/icons/icon-margin-nav-notification.svg"));
var _iconContacts = _interopRequireDefault(require("../../../images/icons/icon-contacts.svg"));
var _iconKey = _interopRequireDefault(require("../../../images/icons/icon-key.svg"));
var _iconReports = _interopRequireDefault(require("../../../images/icons/icon-reports.svg"));
var _iconSecurity = _interopRequireDefault(require("../../../images/icons/icon-security.svg"));
var _iconTasks = _interopRequireDefault(require("../../../images/icons/icon-tasks.svg"));
var _iconHeart = _interopRequireDefault(require("../../../images/icons/icon-heart.svg"));
var _iconFriends = _interopRequireDefault(require("../../../images/icons/icon-friends.svg"));
var _iconPaint = _interopRequireDefault(require("../../../images/icons/icon-paint.svg"));
var _iconSendWithBorder = _interopRequireDefault(require("../../../images/icons/icon-send-with-border.svg"));
var _iconReceiveWithBorder = _interopRequireDefault(require("../../../images/icons/icon-receive-with-border.svg"));
var _iconDepositWithBorder = _interopRequireDefault(require("../../../images/icons/icon-deposit-with-border.svg"));
var _iconWithdrawWithBorder = _interopRequireDefault(require("../../../images/icons/icon-withdraw-with-border.svg"));
var _iconOpenBuyBig = _interopRequireDefault(require("../../../images/icons/icon-open-buy-big.svg"));
var _iconOpenSellBig = _interopRequireDefault(require("../../../images/icons/icon-open-sell-big.svg"));
var _iconCaretPrev = _interopRequireDefault(require("../../../images/icons/icon-caret-prev.svg"));
var _iconCaretNext = _interopRequireDefault(require("../../../images/icons/icon-caret-next.svg"));
var _iconDoubleCaretPrev = _interopRequireDefault(require("../../../images/icons/icon-double-caret-prev.svg"));
var _iconDoubleCaretNext = _interopRequireDefault(require("../../../images/icons/icon-double-caret-next.svg"));
var _iconDropdown = _interopRequireDefault(require("../../../images/icons/icon-dropdown.svg"));
var _iconBarcode = _interopRequireDefault(require("../../../images/icons/icon-barcode.svg"));
var _iconCalendar = _interopRequireDefault(require("../../../images/icons/icon-calendar.svg"));
var _iconEye = _interopRequireDefault(require("../../../images/icons/icon-eye.svg"));
var _iconInfo = _interopRequireDefault(require("../../../images/icons/icon-info.svg"));
var _iconClear = _interopRequireDefault(require("../../../images/icons/icon-clear.svg"));
var _iconDownload = _interopRequireDefault(require("../../../images/icons/icon-download.svg"));
var _iconCheck = _interopRequireDefault(require("../../../images/icons/icon-check.svg"));
var _iconSimpleCheck = _interopRequireDefault(require("../../../images/icons/icon-simple-check.svg"));
var _iconRefresh = _interopRequireDefault(require("../../../images/icons/icon-refresh.svg"));
var _iconClose = _interopRequireDefault(require("../../../images/icons/icon-close.svg"));
var _iconBuy = _interopRequireDefault(require("../../../images/icons/icon-buy.svg"));
var _iconSell = _interopRequireDefault(require("../../../images/icons/icon-sell.svg"));
var _iconSend = _interopRequireDefault(require("../../../images/icons/icon-send.svg"));
var _iconReceive = _interopRequireDefault(require("../../../images/icons/icon-receive.svg"));
var _iconDeposit = _interopRequireDefault(require("../../../images/icons/icon-deposit.svg"));
var _iconWithdraw = _interopRequireDefault(require("../../../images/icons/icon-withdraw.svg"));
var _iconCopy = _interopRequireDefault(require("../../../images/icons/icon-copy.svg"));
var _iconStar = _interopRequireDefault(require("../../../images/icons/icon-star.svg"));
var _iconStop = _interopRequireDefault(require("../../../images/icons/icon-stop.svg"));
var _logoPowered = _interopRequireDefault(require("../../../images/icons/logo-powered.svg"));
var _iconNavNotification = _interopRequireDefault(require("../../../images/icons/icon-nav-notification.svg"));
var _iconCenter = _interopRequireDefault(require("../../../images/icons/icon-center.svg"));
var _iconCheckbox = _interopRequireDefault(require("../../../images/icons/icon-checkbox.svg"));
var _iconMenuToggle = _interopRequireDefault(require("../../../images/icons/icon-menu-toggle.svg"));
var _iconKeyBig = _interopRequireDefault(require("../../../images/icons/icon-key-big.svg"));
var _iconArrowPrev = _interopRequireDefault(require("../../../images/icons/icon-arrow-prev.svg"));
var _iconArrowNext = _interopRequireDefault(require("../../../images/icons/icon-arrow-next.svg"));
var _iconArrowNextThin = _interopRequireDefault(require("../../../images/icons/icon-arrow-next-thin.svg"));
var _iconPending = _interopRequireDefault(require("../../../images/icons/icon-pending.svg"));
var _iconSettings = _interopRequireDefault(require("../../../images/icons/icon-settings.svg"));
var _iconAlert = _interopRequireDefault(require("../../../images/icons/icon-alert.svg"));
var _iconMenu = _interopRequireDefault(require("../../../images/icons/icon-menu.svg"));
var _iconPlusMinus = _interopRequireDefault(require("../../../images/icons/icon-plus-minus.svg"));
var _iconArrowUp = _interopRequireDefault(require("../../../images/icons/icon-arrow-up.svg"));
var _iconArrowDown = _interopRequireDefault(require("../../../images/icons/icon-arrow-down.svg"));
var _iconExchange = _interopRequireDefault(require("../../../images/icons/icon-exchange.svg"));
var _iconGlobe = _interopRequireDefault(require("../../../images/icons/icon-globe.svg"));
var _iconDrag = _interopRequireDefault(require("../../../images/icons/icon-drag.svg"));
var _iconProfile = _interopRequireDefault(require("../../../images/icons/icon-profile.svg"));
var _iconAccount = _interopRequireDefault(require("../../../images/icons/icon-account.svg"));
var _iconDanger = _interopRequireDefault(require("../../../images/icons/icon-danger.svg"));
var _iconCalculator = _interopRequireDefault(require("../../../images/icons/icon-calculator.svg"));
var _iconOrderbookBoth = _interopRequireDefault(require("../../../images/icons/icon-orderbook-both.svg"));
var _iconOrderbookBuy = _interopRequireDefault(require("../../../images/icons/icon-orderbook-buy.svg"));
var _iconOrderbookSell = _interopRequireDefault(require("../../../images/icons/icon-orderbook-sell.svg"));
var _iconTransfer = _interopRequireDefault(require("../../../images/icons/icon-transfer.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// navigation

// user settings

// tables

//pagination

//forms

//ap

//misc

//order entry

//orderbook

var baseClass = 'ap-icon';
var icons = {
  // navigation
  spot: _iconNavSpot["default"],
  margin: _iconNavMargin["default"],
  futures: _iconNavFutures["default"],
  'buy-sell': _iconNavBuySell["default"],
  dashboard: _iconNavDashboardOn["default"],
  trading: _iconNavTrading["default"],
  assets: _iconNavAssets["default"],
  assetActivity: _iconNavActivity["default"],
  streaming: _iconNavStreaming["default"],
  'open-term': _iconNavOpenTerm["default"],
  'fixed-term': _iconNavFixedTerm["default"],
  user: _iconNavUser["default"],
  'user-settings': _iconNavSettings["default"],
  wallet: _iconNavWallet["default"],
  balance: _iconBalance["default"],
  activity: _iconActivity["default"],
  marginNavNotification: _iconMarginNavNotification["default"],
  // user-settings
  contacts: _iconContacts["default"],
  key: _iconKey["default"],
  reports: _iconReports["default"],
  security: _iconSecurity["default"],
  tasks: _iconTasks["default"],
  heart: _iconHeart["default"],
  paint: _iconPaint["default"],
  friends: _iconFriends["default"],
  // table
  sendWithBorder: _iconSendWithBorder["default"],
  receiveWithBorder: _iconReceiveWithBorder["default"],
  depositWithBorder: _iconDepositWithBorder["default"],
  withdrawWithBorder: _iconWithdrawWithBorder["default"],
  'open-buy': _iconOpenBuyBig["default"],
  'open-sell': _iconOpenSellBig["default"],
  //pagination
  caretPrevious: _iconCaretPrev["default"],
  caretNext: _iconCaretNext["default"],
  doubleCaretPrevious: _iconDoubleCaretPrev["default"],
  doubleCaretNext: _iconDoubleCaretNext["default"],
  // forms
  dropdown: _iconDropdown["default"],
  barcode: _iconBarcode["default"],
  calendar: _iconCalendar["default"],
  eye: _iconEye["default"],
  info: _iconInfo["default"],
  cancel: _iconClear["default"],
  download: _iconDownload["default"],
  check: _iconCheck["default"],
  'simple-check': _iconSimpleCheck["default"],
  refresh: _iconRefresh["default"],
  close: _iconClose["default"],
  buy: _iconBuy["default"],
  sell: _iconSell["default"],
  receive: _iconReceive["default"],
  send: _iconSend["default"],
  deposit: _iconDeposit["default"],
  withdraw: _iconWithdraw["default"],
  copy: _iconCopy["default"],
  star: _iconStar["default"],
  stop: _iconStop["default"],
  arrowPrevious: _iconArrowPrev["default"],
  arrowNext: _iconArrowNext["default"],
  arrowNextThin: _iconArrowNextThin["default"],
  //ap
  'logo-powered': _logoPowered["default"],
  //misc and possibly unused
  notification: _iconNavNotification["default"],
  center: _iconCenter["default"],
  checkbox: _iconCheckbox["default"],
  'menu-toggle': _iconMenuToggle["default"],
  bigKey: _iconKeyBig["default"],
  pending: _iconPending["default"],
  settings: _iconSettings["default"],
  alert: _iconAlert["default"],
  danger: _iconDanger["default"],
  menu: _iconMenu["default"],
  plusMinus: _iconPlusMinus["default"],
  arrowUp: _iconArrowUp["default"],
  arrowDown: _iconArrowDown["default"],
  exchange: _iconExchange["default"],
  globe: _iconGlobe["default"],
  //order entry
  calculator: _iconCalculator["default"],
  //orderbook
  'orderbook-both': _iconOrderbookBoth["default"],
  'orderbook-buy': _iconOrderbookBuy["default"],
  'orderbook-sell': _iconOrderbookSell["default"],
  transfer: _iconTransfer["default"],
  drag: _iconDrag["default"],
  profile: _iconProfile["default"],
  account: _iconAccount["default"]
};
var APIcon = function APIcon(props) {
  var name = props.name,
    customClass = props.customClass,
    classModifiers = props.classModifiers;
  var modifiers = (0, _cssClassesHelper.addModifier)(classModifiers, name);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass, customClass]);
  var icon = icons[name];
  return /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon,
    className: bemClasses(null, modifiers),
    "aria-hidden": "true"
  });
};
APIcon.defaultProps = {
  name: '',
  customClass: 'custom-icon',
  classModifiers: '',
  disabled: false
};
APIcon.propTypes = {
  name: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  disabled: _propTypes["default"].bool
};
var _default = exports["default"] = APIcon;